import { feature as accountInfoFeature } from '@central-products/account-info';

// TODO: to be removed and moved into default features list
export const accountInfoPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(accountInfoFeature);
  },
};
